import { ConfigService } from './config.service';
import { Utils } from '../Utils/utils';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ErrorHandleService } from '../sharedmodule/errordialog.component';
import { Incident } from '../model/models';

@Injectable()
export class DiagService {
  public odsUrl: string;

  public observable: Observable<any>;

  constructor(
    private http: HttpClient,
    private utils: Utils,
    private config: ConfigService,
    private errorHandleService: ErrorHandleService,
  ) {
    this.odsUrl = this.config.odsUrl;
  }

  public GetIncidentByIdOrTenantAsync(incidentId?: string): Observable<Incident[]> {
    const headers = this.utils.GetRequestHeaders();
    let url = `${this.odsUrl}v1/incident`;
    if (incidentId) {
      url = url.concat('?incidentid=', incidentId);
    }

    this.observable = this.http
      .get(url, { headers, observe: 'response' })
      .map((response) => {
        if (response.status == 200) {
          return <Incident[]>response.body;
        }
      })
      .share()
      .catch((error) => {
        return this.HandleError(error);
      });
    return this.observable;
  }

  private HandleError(error: HttpErrorResponse) {
    this.observable = null;
    let errorMessage = 'Something went wrong.';
    if (error instanceof HttpErrorResponse && !!error.status) {
      const err = JSON.stringify(error.error) || error.message;
      errorMessage = `${error.status} - ${error.statusText || ''} - Details ${err}`;
      if (error.status == 401) {
        errorMessage = localStorage.getItem('authInstruction');
      }
      if (error.status == 400) {
        errorMessage = `${JSON.stringify(error.error) || error.message}`;
      }
    }

    const statuscode = error.status ? error.status : '500';

    let data = {};
    data = {
      reason: errorMessage,
      status: statuscode,
    };
    this.errorHandleService.openDialog(data);
    return Observable.throw(errorMessage);
  }
}
